import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import SliderContent from "../../components/slider/default";
import {useParams} from "react-router";
import Helmet from "react-helmet";
import axios from "axios";
import LoaderComponent from "../../components/basic/loader";
import {Link} from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import {BsLink45Deg} from "react-icons/bs";
import {AiFillAndroid, AiFillApple, AiFillFacebook, AiFillTwitterSquare} from "react-icons/ai";
import {FaGitAlt} from "react-icons/fa";
import {BiLogoTelegram} from "react-icons/bi";

function SinglePortfolioPage(props) {

    let {slug} = useParams();

    const { t, i18n } = useTranslation()

    const _lang = i18n.language;

    // Example
    // https://api.lukyanchuk.com/api/v1/public/data/project/zhytomyr-land

    const STORAGE_URL = 'https://storage.lukyanchuk.com';

    const API_URL = 'https://api.lukyanchuk.com/api/v1/public/data/project/' + slug;

    const [data, setData] = useState([]);

    useEffect(() => {

        axios.get(API_URL, {}).then( response => {

            setData(response.data.data)

            console.log(response.data.data)

        }).catch(e => console.log(e.message))

    }, [])

    if(data === null) {
        return <LoaderComponent
            text={slug}
            smallText={slug}
        />;
    }

    //TODO: optimization
    const _field = (field) => {

        let option = _lang + '_' + field;

        switch (option){
            case 'en_name':
                return data.name?.en;
                break;
            case 'ua_name':
                return data.name?.ua;
                break;

            case 'en_description':
                return data.description?.en;
                break;
            case 'ua_description':
                return data.description?.ua;
                break;

            case 'en_content':
                return data.content?.en;
                break;
            case 'ua_content':
                return data.content?.ua;
                break;

            default:
                return '';
        }
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('.');
    }

    //TODO: add more social media + email
    {/*<p>*/}
    {/*    <a onClick={()=>gaEventTracker('share-facebook')} href={'https://www.facebook.com/sharer/sharer.php?u=https://lukyanchuk.com/portfolio/' + project.slug} className={'p-2 lead text-secondary'} target="_blank">Facebook</a>*/}
    {/*    <a onClick={()=>gaEventTracker('share-twitter')} href={'https://twitter.com/intent/tweet?url=https://lukyanchuk.com/portfolio/'+ project.slug} className={'p-2 lead text-secondary'} target="_blank">Twitter</a>*/}
    {/*    <a onClick={()=>gaEventTracker('share-telegram')} href={'https://telegram.me/share/url?url=https://lukyanchuk.com/portfolio/'+ project.slug + "&text=" + project.name[i18n.language]} className={'p-2 lead text-secondary'} target="_blank">Telegram</a>*/}
    {/*</p>*/}
    const _share = [
        {
            name: 'Facebook',
            url: 'www.facebook.com/sharer/sharer.php?u=',
            color: 'primary',
            icon: <AiFillFacebook className={'m-1'} />
        },
        {
            name: 'X/Twitter',
            url: 'twitter.com/intent/tweet?url=',
            color: 'dark',
            icon: <AiFillTwitterSquare className={'m-1'} />
        },
        {
            name: 'Telegram',
            url: 'telegram.me/share/url?url=',
            color: 'info',
            icon: <BiLogoTelegram color={'white'} className={'m-1'} />
        }
    ];

    // const gaEventTracker = useAnalyticsEventTracker('Project: ' + slug);

    return (<div className={'min-vh-100 pt-5'}>

        <Helmet>
            <title>{slug} - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />

            {/*<title>{i18n.language === 'en' ? project.name.en :  project.name.ua}</title>*/}
            {/*/!*<meta name="description" content={postSingle.body.en.length > 100 ? postSingle.body.en.substr(0, 100) + '...' : postSingle.body.en} />*!/*/}
            {/*<meta name="keywords" content={Array.isArray(project.tags) ? project.tags.map((tag, i) => tag.label) : 'Software Developer, Yaroslav Lukyanchuk, Laravel, Flutter, React JS, Web Development, Mobile Development, iOS Development, Android Development'} />*/}
            {/*<meta name="author" content={'Yaroslav Lukyanchuk Ярослав Лук\'янчук'} />*/}
            {/*<meta name="description" content={i18n.language === 'en' ? project.description.en :  project.description.ua} />*/}
            {/*{*/}
            {/*    Array.isArray(project.tags) ? project.tags.map((tag, i) => <meta key={i} property="article:tag" content={tag.label} />) : ''*/}
            {/*}*/}

            {/*<meta name="author" content="Yaroslav Lukyanchuk" />*/}
            {/*<meta name="copyright" content="Yaroslav Lukyanchuk" />*/}
            {/*<meta name="application-name" content="Yaroslav Lukyanchuk" />*/}

            {/*/!*TODO: ended meta tag content*!/*/}

            {/*//  For Facebook */}
            {/*<meta property="og:title" content={i18n.language === 'en' ? project.name.en :  project.name.ua} />*/}
            {/*<meta property="og:type" content="article" />*/}
            {/*<meta property="og:image" content={project.image.url != null ? project.image.url : 'https://images.unsplash.com/photo-1668400121008-6134fd5b104d'} />*/}
            {/*<meta property="og:url" content="" />*/}
            {/*<meta property="og:description" content="" />*/}

            {/*// <!-- For Twitter -->*/}
            {/*<meta name="twitter:card" content="summary" />*/}
            {/*<meta name="twitter:title" content={i18n.language === 'en' ? project.name.en :  project.name.ua} />*/}
            {/*<meta name="twitter:description" content="" />*/}
            {/*<meta name="twitter:image" content={project.image.url != null ? project.image.url : 'https://images.unsplash.com/photo-1668400121008-6134fd5b104d'} />*/}

        </Helmet>

        <div className="text-center">
            <div id={'whtat-todo__title-position'} className="p-5">
                <small className="text-secondary">
                    project
                </small>

                <h2 className={'display-1'}>
                   {_field('name')}
                </h2>
            </div>

            <div className="d-flex flex-wrap align-items-center justify-content-center">
                <div className="item p-1">
                    <small className="text-secondary border rounded-5 p-2">
                       release date: {formatDate(data.deadline)}
                    </small>
                </div>

                <div className="item p-1">
                    <small className="text-secondary border rounded-5 p-2">
                       type: {data.type?.en}
                    </small>
                </div>

                <div className="item p-1">
                    <small className="text-secondary border rounded-5 p-2">
                       service: {data.service?.name?.en}
                    </small>
                </div>

                <div className="item p-1">
                    <small className="text-secondary border rounded-5 p-2">
                       category: {data.category?.name?.en}
                    </small>
                </div>
            </div>

        </div>

        <div className="container-fluid text-dark text-start pt-5 mt-5">

            <div className="project-cover-image p-3">
                <Zoom>
                    <img src={data.image?.url} alt={data.image?.name} className={'rounded-5 img-fluid'}/>
                </Zoom>
            </div>


            <div className="description container">

                <div className="description-title mt-5">
                    <h2 className={'display-1 text-secondary1'}>
                        Review
                    </h2>
                </div>

                <div className="description-content pb-5">
                    <p className={'text-justify'} style={{fontSize: "25px"}}>
                        <div dangerouslySetInnerHTML={{__html: _field('description')}} />
                    </p>
                </div>

            </div>

            <div className="slider-content mt-5 pb-5">
                <SliderContent files={data.files} />
            </div>

            <div className="container-fluid bg-dark text-white rounded-5 p-md-5 p-3 mt-5">

                <div className="container row m-auto mt-5">
                    <div className="col-md-6">
                        <h2 className={'display-4'}>
                            Description
                        </h2>
                        <div dangerouslySetInnerHTML={{__html: _field('content')}} />
                    </div>
                    <div className="col-md-6">

                        <div className="result">

                            <div className="description-title">
                                <h2 className={'display-4 text-secondary1'}>Result</h2>
                            </div>

                            <div className="description-content">
                                {
                                    data.links?.map(link => <>
                                        {link?.production_link &&
                                        <Link to={link?.production_link}
                                                                        className="btn btn-light rounded-5 p-4 pt-3 pb-3 m-1">
                                            <BsLink45Deg size={30}/>
                                            <small className="lead p-3">
                                                {link?.production_link}
                                            </small>
                                        </Link>}
                                        {link?.repository_url &&
                                        <Link to={link?.repository_url}
                                                                       className="btn btn-light rounded-5 p-4 pt-3 pb-3 m-1">
                                            <FaGitAlt size={30}/>
                                            <small className="lead p-3">
                                                Repository
                                            </small>
                                        </Link>}
                                        {link?.android &&
                                        <Link to={link?.android} className="btn btn-light rounded-5 p-4 pt-3 pb-3 m-1">
                                            <AiFillAndroid size={30}/>
                                            <small className="lead p-3">
                                                Android APK
                                            </small>
                                        </Link>}
                                        {link?.ios &&
                                        <Link to={link?.ios} className="btn btn-light rounded-5 p-4 pt-3 pb-3 m-1">
                                            <AiFillApple size={30}/>
                                            <small className="lead p-3">
                                                iOS App
                                            </small>
                                        </Link>}
                                    </>)
                                }
                            </div>

                        </div>

                        <div className={'technologies mt-5'}>
                            <h2 className={'display-4'}>
                                Stack Technologies
                            </h2>

                            {/*TODO: add type show portfolio by category/service + limit*/}
                            <div className="d-flex flex-wrap align-items-center mt-1 mb-51">
                                {
                                    // [...Array(8)]
                                    data.tags?.map((e, i) =>
                                        <Link key={i} to={"/projects?tag=" + e.value} className="btn btn-light m-1 border- rounded-5 p-3 pt-2 pb-2">
                                            <i>
                                                <small className="text-secondary">
                                                    {e.label}
                                                </small>
                                            </i>
                                        </Link>
                                    )
                                }
                            </div>
                        </div>

                        <div className="share mt-5">
                            <h2 className={'display-4'}>Share</h2>
                            <div className="d-flex flex-wrap align-items-center">
                                {
                                    // [...Array(5)]
                                    _share.map((e, i) =>

                                        <Link to={"https://" + e.url + window.location.href} className={`btn btn-${e.color} m-1 border border-${e.color === 'dark' ? 'white' : e.color} rounded-5 p-3 pt-2 pb-2`}>
                                            {e.icon}
                                            <small className="text-white">
                                                {e.name}
                                            </small>
                                        </Link>
                                    )
                                }
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div className="example-service-project-work mt-5">

                <div className="container">
                    <h2 className={'display-4'}>Similar project</h2>
                </div>

                {/*TODO: add type show portfolio by category/service + limit*/}
                <div className="d-flex flex-wrap align-items-center mt-5">

                    {/*<CardPortfolio />*/}

                    {/*<CardPortfolio />*/}

                    {/*<CardPortfolio />*/}
                </div>
            </div>

        </div>

        <div className="text-end p-5">
            <Link to="/cooperation" className={'text-decoration-none text-dark display-4'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"
                     className="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                </svg> <b>cooperation</b>
            </Link>
        </div>


    </div>);
}

export default SinglePortfolioPage;
